export enum EDeductionType {
  Number = "Number",
  Percent = "Percent",
  Product = "Product"
}
